/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgTrelloDisabled = (props)=>/*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        height: "1em",
        viewBox: "0 0 32 32",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "TrelloDisabled_svg__a",
        gradientUnits: "userSpaceOnUse",
        x1: 16,
        x2: 16,
        y1: 37.232,
        y2: 12.86
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#344563"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#7a869a"
    })), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M25.288 3.812H6.712a2.904 2.904 0 0 0-2.9 2.9v18.576a2.904 2.904 0 0 0 2.9 2.9h18.576a2.904 2.904 0 0 0 2.9-2.9V6.712a2.904 2.904 0 0 0-2.9-2.9zM14.312 21.368a.964.964 0 0 1-.964.964H9.276a.964.964 0 0 1-.964-.964V9.276a.964.964 0 0 1 .964-.964h4.072a.964.964 0 0 1 .964.964zm9.376-5.552a.964.964 0 0 1-.964.984h-4.072a.964.964 0 0 1-.964-.964v-6.56a.964.964 0 0 1 .964-.964h4.072a.964.964 0 0 1 .964.964z",
        fill: "url(#TrelloDisabled_svg__a)",
        fillRule: "evenodd"
    }));
export default SvgTrelloDisabled;
